"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = adjustStylesForAnchorVisibility;

var _xtend = _interopRequireDefault(require("xtend"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hideStyles = {
  visibility: 'hidden',
  zIndex: -1
};
const showStyles = {
  visibility: 'visible',
  zIndex: 1
};
/**
 * @param {Object} pointerStyle
 * @param {Object} bodyStyle
 * @param {string} placement
 * @param {Object} options - See definition in calculatePosition
 * @param {PopoverPositionContext} context - See definition in calculatePositionContext
 * @return {{ pointerStyle: Object, bodyStyle: Object }}
 */

function adjustStylesForAnchorVisibility(pointerStyle, bodyStyle, placement, options, context) {
  const hideThings = () => {
    const newPointerStyle = (0, _xtend.default)(pointerStyle, hideStyles);
    const newBodyStyle = options.hideWhenAnchorIsOffscreen ? (0, _xtend.default)(bodyStyle, hideStyles) : bodyStyle;
    return {
      pointerStyle: newPointerStyle,
      bodyStyle: newBodyStyle
    };
  };

  const showThings = () => {
    const newPointerStyle = (0, _xtend.default)(pointerStyle, showStyles);
    const newBodyStyle = options.hideWhenAnchorIsOffscreen ? (0, _xtend.default)(bodyStyle, showStyles) : bodyStyle;
    return {
      pointerStyle: newPointerStyle,
      bodyStyle: newBodyStyle
    };
  };

  const win = (0, _getWindow.default)();
  const scrollableParent = options.getScrollableParentElement !== undefined ? options.getScrollableParentElement() : null;

  if (!scrollableParent) {
    return {
      pointerStyle,
      bodyStyle
    };
  }

  const scrollY = win.pageYOffset;
  let scrollableParentTop;
  let scrollableParentBottom;

  if (scrollableParent === win) {
    scrollableParentTop = options.containWithinViewport ? scrollY : 0;
    scrollableParentBottom = options.containWithinViewport ? scrollY + win.innerHeight : context.availableHeight;
  } else {
    const scrollableParentRect = scrollableParent.getBoundingClientRect();
    scrollableParentTop = scrollableParentRect.top + scrollY;
    scrollableParentBottom = scrollableParentRect.bottom + scrollY;
  }

  const offsetFromScrollableParentTopEdge = Math.round(context.anchorVerticalCenter - options.pointerBase / 2) - 2;
  const offsetFromScrollableParentBottomEdge = Math.round(context.anchorVerticalCenter + options.pointerBase / 2) + 2;
  const onLeftOrRight = placement === _constants.PLACEMENT_LEFT || placement === _constants.PLACEMENT_RIGHT;

  if (placement === _constants.PLACEMENT_TOP && scrollableParentTop > context.anchorAbsoluteTop || placement === _constants.PLACEMENT_BOTTOM && scrollableParentBottom < context.anchorAbsoluteTop || !onLeftOrRight && scrollableParentBottom < context.anchorAbsoluteTop || !onLeftOrRight && scrollableParentTop > context.anchorAbsoluteBottom || onLeftOrRight && ( // Offset the allowed top/bottom to prevent the pointer triangle from appearing
  // beyond the border curves
  scrollableParentTop + options.pointerBase / 2 + 1 > offsetFromScrollableParentTopEdge || scrollableParentBottom - options.pointerBase / 2 - 1 < offsetFromScrollableParentBottomEdge)) {
    return hideThings();
  } else {
    return showThings();
  }
}